import { PRODUCT_NAME_AI_AGENT_PLAN_TEE } from '@base/settings';
import { useAgentPlan } from './useAgentPlan';

export const useTeeAgentPlan = () => {
  return useAgentPlan({
    planName: PRODUCT_NAME_AI_AGENT_PLAN_TEE,
  });
};
